import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-final-idea',
  imports: [],
  templateUrl: './iackathon-step-final-idea.component.html',
  styleUrl: './iackathon-step-final-idea.component.scss',
})
export class IackathonStepFinalIdeaComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    protected finalIdea = computed(() => this.state().solution_step?.chosen_idea?.idea);

}
